import type { PaymentCancelStatus, PaymentStatus } from '@repo/api-contracts';

interface StatusLabel {
  readonly label: string;
  readonly className: string;
}

export const PAYMENT_STATUS_LABELS: Readonly<Record<PaymentStatus, StatusLabel>> = {
  READY: { label: '결제 대기', className: 'text-muted-foreground' },
  DONE: { label: '결제 완료', className: 'text-foreground' },
  PARTIAL_CANCELED: { label: '부분 환불', className: 'text-amber-600' },
  CANCELED: { label: '전액 환불', className: 'text-muted-foreground' },
  ABORTED: { label: '승인 실패', className: 'text-destructive' },
  EXPIRED: { label: '만료', className: 'text-muted-foreground' },
};

export const PAYMENT_CANCEL_STATUS_LABELS: Readonly<Record<PaymentCancelStatus, StatusLabel>> = {
  PENDING: { label: '처리 중', className: 'text-amber-600' },
  DONE: { label: '환불 완료', className: 'text-foreground' },
  FAILED: { label: '환불 실패', className: 'text-destructive' },
};
